import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { DataCatalogQuery } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useDataCatalogMetadata } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogMetadata'
import tableTypeToIcon from 'modules/ai_reports/lib/tableTypeToIcon'

import './index.styles.css'

type Props = {
  datasources: DataCatalogQuery['iris']['factTablesConnection']['edges'][number]['node'][]
  selectedDatasourceId: string | undefined
  onSelectDatasource?: (sourceId: string) => void
}

const DataCatalogList = ({ datasources, onSelectDatasource, selectedDatasourceId }: Props) => {
  const { getDataCatalogMetadata } = useDataCatalogMetadata()

  const items = useUnsafeMemo(
    () =>
      datasources
        // We want to disable _current views for now. Also, if we for some
        // reson we wan to enable them again, we should fix the table because is not
        // updating correctly when the agent changes the filters.
        .filter((node) => !node.id.includes('_current'))
        .map((node) => ({
          icon: tableTypeToIcon(node.id),
          id: node.id,
          label: node.name,
          tooltip: node.description,
          tag: node.tag,
          onClick: () => {
            onSelectDatasource?.(node.id)
          },
        })),
    [datasources, onSelectDatasource]
  )

  const groupedItems = useUnsafeMemo(
    () =>
      Object.entries(groupBy(items, 'tag')).map(([tag, items]) => {
        const metadata = getDataCatalogMetadata(tag)
        return {
          icon: metadata.icon,
          id: tag,
          label: metadata.label,
          children: items,
        }
      }),
    [items, getDataCatalogMetadata]
  )

  return (
    <F0TableOfContent
      className="DataCatalogList_DataCatalogListItems"
      title=""
      showSearchBox
      hideChildrenCounter
      activeItem={selectedDatasourceId}
      items={groupedItems}
    />
  )
}

export default DataCatalogList
